import HeroContent from 'components/HeroConsolidated/shared/HeroContent';
import HeroWrapper, { HeroContentWrapper } from 'components/HeroConsolidated/shared/HeroWrapper';
import { HeroConsolidatedProps } from 'libs/contentful/props';
import { Colorways } from 'types/constants';
import BlogAuthor from './shared/BlogAuthor';
import { formatDate } from 'utils/formatters';
import Media from 'components/shared/Media/Media';
import { HeroBlogImageSize } from './constants';
import { cn } from 'utils/styles';
import { liveUpdateAttrs } from 'libs/contentful/utils';

const HeroBlogVariant = ({
  headline,
  sys,
  copy,
  margins,
  sectionName,
  author,
  blogDate,
  desktopMedia,
  showBlogImage,
  blogImageSize,
  className,
  innerClassName,
  isInactiveCarouselSlide,
}: HeroConsolidatedProps) => {
  // Blog Variant does not support any colorway other than white
  const color = { name: Colorways.Primary, value: '#fff' };

  const formattedDate = blogDate ? formatDate(blogDate) : null;
  const displayImage = showBlogImage && desktopMedia != null;

  return (
    <HeroWrapper
      color={color}
      margins={margins}
      sectionName={sectionName}
      className={cn(className, 'py-4 sm:py-4')}
      innerClassName={cn('sm:flex-col sm:gap-20 sm:w-2/3', innerClassName)}
      isInactiveCarouselSlide={isInactiveCarouselSlide}>
      <HeroContentWrapper className="sm:w-full sm:max-w-full">
        {blogDate && (
          <p className="hero-eyebrow text-eyebrow font-sans pb-6" {...liveUpdateAttrs(sys?.id, 'blogDate')}>
            {formattedDate}
          </p>
        )}
        <HeroContent headline={headline} copy={copy} sys={sys} />
        {author && <BlogAuthor {...author} className="py-4" />}
      </HeroContentWrapper>
      {displayImage && (
        <div
          className={cn('with-sidebar-layout-sidebar', {
            'aspect-video ': blogImageSize === HeroBlogImageSize.FourThree,
          })}>
          <Media
            media={desktopMedia}
            className={cn({
              'sm:max-h-[500px]': blogImageSize === HeroBlogImageSize.FourThree,
              'sm:max-h-[300px] max-h-[125px] object-cover': blogImageSize === HeroBlogImageSize.Wide,
            })}
          />
        </div>
      )}
    </HeroWrapper>
  );
};

export default HeroBlogVariant;
